import { render, staticRenderFns } from "./AboutPageWhoWeAre.vue?vue&type=template&id=85710c62&scoped=true"
import script from "./AboutPageWhoWeAre.vue?vue&type=script&lang=ts"
export * from "./AboutPageWhoWeAre.vue?vue&type=script&lang=ts"
import style0 from "./AboutPageWhoWeAre.vue?vue&type=style&index=0&id=85710c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85710c62",
  null
  
)

export default component.exports